import React from 'react';
import styled from 'styled-components';
import { colors } from '../../../../../globalStyles';
import { ScoreDeltaDirection } from '../AssessmentIndex.types';
import { DeltaArrow } from './DeltaArrow';
import { DELTA_DECREASE_COLOR } from '../AssessmentIndex.constants';
import { formatDisplayValue } from '../utils';

type ScoreDeltaProps = {
  delta?: number | null;
};

export const ScoreDelta = ({ delta }: ScoreDeltaProps) => {
  if (delta == null) return null;

  const displayedDelta = Number(formatDisplayValue(delta));
  const direction: ScoreDeltaDirection =
    displayedDelta > 0 ? 'increase' : displayedDelta < 0 ? 'decrease' : 'unchanged';
  const points = Math.abs(displayedDelta);
  const formattedPoints = formatDisplayValue(points);

  return (
    <DeltaBadge $direction={direction} aria-label={`${formattedPoints} point ${direction}`}>
      <DeltaArrow direction={direction} />
      {formattedPoints} {points === 1 ? 'point' : 'points'}
    </DeltaBadge>
  );
};

const DeltaBadge = styled.div<{ $direction: 'increase' | 'decrease' | 'unchanged' }>`
  display: flex;
  align-items: center;
  gap: 7px;
  min-width: 112px;
  justify-content: center;
  padding: 5px 12px;
  border-radius: 14px;
  background-color: ${({ $direction }) =>
    $direction === 'increase'
      ? colors.success
      : $direction === 'decrease'
      ? DELTA_DECREASE_COLOR
      : colors.grey.dark};
  color: ${colors.white};
  font-size: 13px;
  font-weight: 700;
`;
